const mapStyles = [
    {
        'featureType': 'administrative',
        'elementType': 'all',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'geometry',
        'stylers':     [
            {
                'color': '#a7a7a7'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'labels',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'labels.text',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'labels.text.fill',
        'stylers':     [
            {
                'visibility': 'on'
            },
            {
                'color': '#737373'
            }
        ]
    },
    {
        'featureType': 'landscape',
        'elementType': 'all',
        'stylers':     [
            {
                'saturation': '0'
            }
        ]
    },
    {
        'featureType': 'landscape',
        'elementType': 'geometry.fill',
        'stylers':     [
            {
                'visibility': 'on'
            },
            {
                'color': '#efefef'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'all',
        'stylers':     [
            {
                'saturation': '-100'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'geometry.fill',
        'stylers':     [
            {
                'visibility': 'on'
            },
            {
                'color': '#dadada'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'labels',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'labels.icon',
        'stylers':     [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'poi.attraction',
        'elementType': 'labels',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'poi.business',
        'elementType': 'all',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'poi.government',
        'elementType': 'all',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'poi.medical',
        'elementType': 'all',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'poi.park',
        'elementType': 'all',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'poi.sports_complex',
        'elementType': 'all',
        'stylers':     [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'labels.text.fill',
        'stylers':     [
            {
                'color': '#696969'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'labels.icon',
        'stylers':     [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers':     [
            {
                'color': '#ffffff'
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers':     [
            {
                'visibility': 'on'
            },
            {
                'color': '#b3b3b3'
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.fill',
        'stylers':     [
            {
                'color': '#ffffff'
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.stroke',
        'stylers':     [
            {
                'color': '#d6d6d6'
            }
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry.fill',
        'stylers':     [
            {
                'visibility': 'on'
            },
            {
                'color': '#ffffff'
            },
            {
                'weight': 1.8
            }
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry.stroke',
        'stylers':     [
            {
                'color': '#d7d7d7'
            }
        ]
    },
    {
        'featureType': 'transit',
        'elementType': 'all',
        'stylers':     [
            {
                'color': '#000000'
            },
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'transit.station',
        'elementType': 'all',
        'stylers':     [
            {
                'visibility': 'off'
            },
            {
                'hue': '#ff0000'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers':     [
            {
                'color': '#d3d3d3'
            }
        ]
    }
];

export default mapStyles;
